import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import classNames from 'classnames';
import { FormattedMessage } from '../../../../util/reactIntl';
import MobileReviews from '../MobileReviews/MobileReviews';
import DesktopReviews from '../DesktopReviews/DesktopReviews';
import SearchBar from '../SearchBar/SearchBar';
import { H2, ListingCard, PaginationLinks } from '../../../../components';
import { useRouteConfiguration } from '../../../../context/routeConfigurationContext';

import css from '../../ProfilePage.module.css';

const MAX_MOBILE_SCREEN_WIDTH = 768;

const MainContent = ({
  userShowError,
  bio,
  pagination,
  listings,
  queryListingsError,
  reviews,
  queryReviewsError,
  viewport,
  isBuyer,
  showReviewAsCustomer,
  currentPage,
  queryParams,
  onManageDisableScrolling,
  intl,
  config,
  userId,
  isPremiumPartners,
}) => {
  const history = useHistory();
  const location = useLocation();
  const routeConfiguration = useRouteConfiguration();

  const hasListings = listings.length > 0;
  const isMobileLayout = viewport.width < MAX_MOBILE_SCREEN_WIDTH;
  const hasBio = !!bio;

  const listingsContainerClasses = classNames(css.listingsContainer, {
    [css.withBioMissingAbove]: !hasBio,
  });

  const paginationLinks =
    pagination && pagination.totalPages > 1 ? (
      <PaginationLinks
        className={css.pagination}
        pageName={currentPage}
        pageSearchParams={queryParams}
        pagination={pagination}
        pagePathParams={{ id: userId }}
      />
    ) : null;

  if (userShowError || queryListingsError) {
    return (
      <p className={css.error}>
        <FormattedMessage id="ProfilePage.loadingDataFailed" />
      </p>
    );
  }
  return (
    <div>
      {isBuyer ? null : (
        <H2 as="h1" className={css.desktopHeading}>
          <FormattedMessage id="ProfilePage.heading" values={{ count: pagination?.totalItems ?? listings.length }} />
        </H2>
      )}
      {hasBio ? <p className={css.bio}>{bio}</p> : null}

      {isPremiumPartners ?
        (
          <SearchBar
            intl={intl}
            searchParams={queryParams}
            location={location}
            config={config}
            history={history}
            routeConfiguration={routeConfiguration}
            onManageDisableScrolling={onManageDisableScrolling}
            listings={listings}
            searchListingsError={false}
            searchInProgress={false}
            userId={userId}
          />
        ) : null
      }

      {hasListings ? (
        <div className={listingsContainerClasses}>
          <ul className={css.listings}>
            {listings.map(l => (
              <li className={css.listing} key={l.id.uuid}>
                <ListingCard listing={l} showAuthorInfo={false} className={css.listingCard} />
              </li>
            ))}
          </ul>
        </div>
      ) : null}

      {paginationLinks}

      {isMobileLayout ? (
        <MobileReviews
          isBuyer={isBuyer}
          showReviewAsCustomer={showReviewAsCustomer}
          reviews={reviews}
          queryReviewsError={queryReviewsError}
        />
      ) : (
        <DesktopReviews
          isBuyer={isBuyer}
          reviews={reviews}
          queryReviewsError={queryReviewsError}
          showReviewAsCustomer={showReviewAsCustomer}
        />
      )}
    </div>
  );
};

export default MainContent;
